import React from 'react';
import { Dialog } from '@headlessui/react';
import { XMarkIcon, CheckIcon } from '@heroicons/react/24/outline';
import { Link } from '@tanstack/react-router';
import { trackSignUpDialogClick } from '../utils/analytics';
import { fillTemplate, useHomeStrings } from '../i18n';

export default function SignUpPromptDialog({ isOpen, onClose, fileName, fileSize, reason = 'file-size' }) {
  const t = useHomeStrings().dialog;
  const sizeLabel = fileSize ? ` (${Number(fileSize).toFixed(2)} MB)` : '';

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-background/80 backdrop-blur-sm" aria-hidden="true" />

      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-md w-full bg-background-elevated rounded-xl shadow-xl border border-border/60">
          <div className="flex items-start justify-between p-6 border-b border-border/50">
            <Dialog.Title className="text-lg font-semibold text-foreground tracking-tight">
              {t.title}
            </Dialog.Title>
            <button
              onClick={onClose}
              className="text-muted-foreground hover:text-foreground transition-colors rounded-lg p-1 hover:bg-background-soft"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>

          <div className="p-6 space-y-6">
            {fileName && (
              <p className="text-sm text-muted-foreground">
                {fillTemplate(t.ready, {
                  file: <span className="font-medium text-foreground">{fileName}</span>,
                  size: sizeLabel,
                })}
              </p>
            )}

            <ul className="space-y-2.5">
              {t.benefits.map((benefit) => (
                <li key={benefit} className="flex items-center gap-2 text-sm text-foreground">
                  <CheckIcon className="h-5 w-5 text-success flex-shrink-0" />
                  {benefit}
                </li>
              ))}
            </ul>

            <p className="text-xs text-muted-foreground/80">
              {t.privacy}
            </p>

            <div className="pt-2">
              <Link
                to="/sign-up"
                className="w-full bg-primary hover:bg-primary-hover text-primary-foreground text-center py-2.5 px-4 rounded-lg font-medium transition-all duration-200 inline-block shadow-sm"
                onClick={() => {
                  trackSignUpDialogClick(reason);
                  onClose();
                }}
              >
                {t.cta}
              </Link>
              <p className="text-xs text-center text-muted-foreground mt-3">{t.noCard}</p>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
